module.exports = "https://bin.bnbstatic.com/_next/static/images/touxiang-7e4811c68fed288a95fe69c286b577e5.png";